<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <marca-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import MarcaProvider from "../../../providers/MarcaProvider";

import { CrudCreate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

import MarcaForm from "../MarcaForm";

export default {
    name: "MarcaCreate",

    components: { MarcaForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "marca.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                nombre: null,
            },
        };
    },

    methods: {
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                MarcaProvider.createMarca(this.form)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemCreated", r.data.marcaCreate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>

<style scoped></style>
